'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link } from 'react-router';

var NewMediumGzhComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NewMediumGzhComponent, _Component);

  function NewMediumGzhComponent() {
    (0, _classCallCheck3.default)(this, NewMediumGzhComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(NewMediumGzhComponent).call(this));

    _this.onMouseOverOrOut = function () {
      _this.setState({
        isQcImgShow: !_this.state.isQcImgShow
      });
    };

    _this.state = {
      isQcImgShow: false
    };
    return _this;
  }

  (0, _createClass3.default)(NewMediumGzhComponent, [{
    key: 'render',
    value: function render() {
      var styles = require('./NewMediumGzhComponent.scss');
      var _props = this.props;
      var data = _props.data;
      var index = _props.index;
      var isQcImgShow = this.state.isQcImgShow;

      return _react2.default.createElement(
        'li',
        { className: styles.gzhli, style: { marginRight: index % 4 === 3 ? '0px' : '9px' } },
        _react2.default.createElement(
          'div',
          { className: styles.img_tu },
          _react2.default.createElement('img', { src: data.img1, alt: '',
            style: { width: '100%' } }),
          _react2.default.createElement('img', { src: data.img2, alt: '',
            className: styles.img_er, style: { display: isQcImgShow ? 'block' : 'none' } }),
          _react2.default.createElement(
            'p',
            { className: styles.img_txt },
            '粉丝数：' + data.fansNum
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.txt_box },
          _react2.default.createElement(
            'div',
            { className: styles.txt },
            _react2.default.createElement(
              'p',
              { className: styles.h1 },
              data.title
            ),
            _react2.default.createElement(
              'p',
              { className: styles.h2 },
              data.content
            )
          ),
          _react2.default.createElement(
            'a',
            { onMouseOver: this.onMouseOverOrOut, onMouseOut: this.onMouseOverOrOut },
            _react2.default.createElement('img', { src: data.qc, alt: '',
              className: styles.icon_er })
          )
        )
      );
    }
  }]);
  return NewMediumGzhComponent;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  index: _react.PropTypes.number
}, _temp);
exports.default = NewMediumGzhComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewMediumGzhComponent/NewMediumGzhComponent.js
 ** module id = 1377
 ** module chunks = 0
 **/